import { Routes, Route } from "react-router-dom";

import PublicLayout from "../../layouts/PublicLayout/PublicLayout";
import NotFoundPage from "./../../pages/Page/NotFoundPage/NotFoundPage";
import HomePublic from "../../pages/Public/HomePublic/HomePublic";

const PublicContainer = () => {
  return (
    <PublicLayout>
      <Routes>
        {/* Home */}
        <Route index element={<HomePublic />} />

        {/* Not Found */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </PublicLayout>
  );
};

export default PublicContainer;
